import XeroAdapter from './base';

export default class Batch extends XeroAdapter {
  modelNamePlural = 'batches';
}
